import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isActiveLink, links } from '../nav-links';
import { currentUserId } from '../../../features/fe-data/selectors';
import getPermissions from '../permissions';
import PdxNavBadge from '../PdxNavBadge';

export const DisconnectedPdxNavPanelSectionItem = ({
  children,
  link,
  newTab,
  badge,
  onClick,
  text,
  hasPermission,
  isActive
}) => {
  const itemLink = link || '';
  return (
    hasPermission && (
      <div
        className={`pdx-nav-panel-section-item${isActive ? ' active' : ''}`}
      >
        <a
          href={itemLink}
          onClick={onClick}
          className="panel-link"
          target={newTab ? '_blank' : '_self'}
        >
          {text}
          {children}
          {badge && (
          <>
            {' '}
            <PdxNavBadge type={badge} />
          </>
          )}
        </a>
      </div>
    )
  );
};

DisconnectedPdxNavPanelSectionItem.defaultProps = {
  link: undefined,
  newTab: false,
  onClick: undefined,
  badge: undefined,
  children: undefined,
  text: undefined,
  hasPermission: true,
  isActive: false,
};

DisconnectedPdxNavPanelSectionItem.propTypes = {
  link: PropTypes.string,
  text: PropTypes.string,
  hasPermission: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string
  ]),
  newTab: PropTypes.bool,
  onClick: PropTypes.func,
  badge: PropTypes.oneOf(['beta', 'new']),
  isActive: PropTypes.bool,
};

export const mapStateToProps = (state, ownProps) => {
  const userId = currentUserId(state);
  const link = ownProps.id ? links(currentUserId(state))[ownProps.id].link : ownProps.link || '';
  return {
    text: ownProps.id ? links(currentUserId(state))[ownProps.id].text : null,
    hasPermission: ownProps.id ? getPermissions(state)[ownProps.id] : (
      ownProps.hasPermission || true
    ),
    link,
    isActive: isActiveLink(link, userId)
  };
};

export default connect(mapStateToProps)(DisconnectedPdxNavPanelSectionItem);
